import {
	init as initSentry,
	replayIntegration,
	tanstackRouterBrowserTracingIntegration,
} from "@sentry/tanstackstart-react";
import { StartClient } from "@tanstack/react-start/client";
import { StrictMode, startTransition } from "react";
import { hydrateRoot } from "react-dom/client";

import { getRouter } from "./router";

const router = getRouter();

initSentry({
	dsn: import.meta.env.VITE_SENTRY_DSN,
	integrations: [
		tanstackRouterBrowserTracingIntegration(router),
		replayIntegration({
			maskAllText: false,
			blockAllMedia: false,
		}),
	],
	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for tracing.
	// We recommend adjusting this value in production.
	// Learn more at https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
	tracesSampleRate: 1.0,
	// Capture Replay for 10% of all sessions,
	// plus for 100% of sessions with an error.
	// Learn more at https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
});

startTransition(() => {
	hydrateRoot(
		document,
		<StrictMode>
			<StartClient />
		</StrictMode>,
	);
});
